export const highlight = {
  darkest: '#006AB5', // LTA Blue — primary brand (primary.main)
  dark: '#338AC4', // derived lighter blue (primary.light)
  medium: '#80B7DD', // derived mid tint (fills the 5-tier gap)
  light: '#E8F2F8', // Brand / Blue shade — surface tint
  lightest: '#FFF7F2', // off-white
  navy: '#16316F',
};

export const neutralLight = {
  darkest: '#C5C6CC',
  dark: '#D4D6DD',
  medium: '#EEEEEE', // LTA Mid Grey
  light: '#FAFBFC',
  lightest: '#FFFFFF',
};

export const neutralDark = {
  darkest: '#131619', // LTA Black
  dark: '#2D343C', // LTA Dark Grey
  medium: '#333A42', // LTA Grey
  light: '#4C5D64', // LTA Dark Slate
  lightest: '#98928F',
};

export const green = {
  dark: '#28A853',
  main: '#6EB96F',
  light: '#EFF8F0',
};

export const support = {
  success: { dark: '#298267', medium: '#3AC0A0', light: '#E7F4E8' },
  warning: { dark: '#E86339', medium: '#FFB37C', light: '#FFF4E4' },
  error: { dark: '#ED3241', medium: '#FF616D', light: '#FFE2E5' },
};

// Centralised so components reference named design tokens rather than inlining
// one-off hex values.
export const semantic = {
  goodExample: { border: '#28A853', shade: '#EFF8F0' },
  badExample: { border: '#DB3624', shade: '#FDF5F4' },
  borderStrong: '#A9B4B8',
  borderDefault: '#CDD4D8',
  instructions: '#6C787E', // Core / UI / Instructions — affordance icons
  progressTrack: '#ECECEF',
  progressText: {
    success: '#387F39',
    empty: '#787371',
  },
};

export const greyScale = {
  50: neutralLight.lightest,
  100: neutralLight.light,
  200: neutralLight.medium,
  300: neutralLight.dark,
  400: neutralLight.darkest,
  500: neutralDark.lightest,
  600: neutralDark.light,
  700: neutralDark.medium,
  800: neutralDark.dark,
  900: neutralDark.darkest,
};
